import React, { createContext, useContext, useState } from "react";

import { SignUpFormType } from "/constant/signUp.constant";

import { Context } from "./SignUpProvider.types";

const INITIAL_STATE = {
  phone: "",
  email: "",
  id: "",
  isEmailVerificationCodeSent: false,
  currentForm: SignUpFormType.CreateAccount,
};

const SignUpProviderContext = createContext<Context>({
  setEmail: () => "",
  setPhone: () => "",
  setId: () => "",
  setEmailVerificationCodeSent: () => undefined,
  setCurrentForm: () => undefined,
  phone: "",
  email: "",
  id: "",
  emailVerificationCode: "",
  isEmailVerificationCodeSent: false,
  currentForm: SignUpFormType.CreateAccount,
});

const SignUpProvider = (props: {
  children: React.ReactNode;
  handleError: () => void;
  emailVerificationCode: string;
}): JSX.Element => {
  const [state, setCurrentState] = useState(INITIAL_STATE);

  const setEmail = (email: string) => {
    setCurrentState({
      ...state,
      email,
    });
  };
  const setPhone = (phone: string) => {
    setCurrentState({
      ...state,
      phone,
    });
  };
  const setId = (id: string) => {
    setCurrentState({
      ...state,
      id,
    });
  };
  const setEmailVerificationCodeSent = (isSent: boolean) => {
    setCurrentState({
      ...state,
      isEmailVerificationCodeSent: isSent,
    });
  };
  const setCurrentForm = (form: SignUpFormType) => {
    setCurrentState({
      ...state,
      currentForm: form,
    });
  };

  return (
    <SignUpProviderContext.Provider
      value={{
        setEmail,
        setPhone,
        setId,
        setEmailVerificationCodeSent,
        setCurrentForm,
        emailVerificationCode: props.emailVerificationCode,
        ...state,
      }}
    >
      {props.children}
    </SignUpProviderContext.Provider>
  );
};

export const useSignUpProvider = () => useContext(SignUpProviderContext);
export default SignUpProvider;
